$( document ).on("turbo:load", function(){
    
  if ($('.user-account-form').length > 0) {

    var validFromYear = $("#user_account_valid_from_1i"),
        validFromMonth = $("#user_account_valid_from_2i"),
        validFromDay = $("#user_account_valid_from_3i"),
        validToYear = $("#user_account_valid_to_1i"),
        validToMonth = $("#user_account_valid_to_2i"),
        validToDay = $("#user_account_valid_to_3i"),
        validToYearsOptions = $("#user_account_valid_to_1i option"),
        validToMonthOptions = $("#user_account_valid_to_2i option"),
        validToDayOptions = $("#user_account_valid_to_3i option");

    validFromYear.on('change', function() {
      changeValidToYearOptions();
    });

    validFromMonth.on('change', function() {
      changeValidToMonthOptions();
    });

    validFromDay.on('change', function() {
      changeValidToDayOptions();
    });

    validToYear.on('change', function() {
      changeValidToYearOptions();
    });

    validToMonth.on('change', function() {
      changeValidToMonthOptions();
    });

    function changeValidToYearOptions() {
      if (validFromYear.val() != '' && validToYear.find(":selected").index() > validFromYear.find(":selected").index()) {
        validToMonthOptions.attr('disabled', false);
      }
      validToYearsOptions.attr('disabled', false);
      if (validFromYear.val() != '') {
        validToYearsOptions.slice(1, validFromYear.find(":selected").index()).attr('disabled', true);
        if (validToYear.val() != '' && validFromYear.val() != '' &&
            validToYear.find(":selected").index() < validFromYear.find(":selected").index()) {
          validToYear.val(validFromYear.val());
        }
      changeValidToMonthOptions();
      }
    }

    function changeValidToMonthOptions() {
      if ((validFromMonth.val() != '' && validToMonth.find(":selected").index() > validFromMonth.find(":selected").index()) ||
          validToYear.find(":selected").index() > validFromYear.find(":selected").index()) {
        validToDayOptions.attr('disabled', false);
      }
      validToMonthOptions.attr('disabled', false);
      if (validToYear.val() == validFromYear.val() && validFromYear.val() != '') {
        validToMonthOptions.slice(1, validFromMonth.find(":selected").index()).attr('disabled', true);
        if (validToMonth.val() != '' && validFromMonth.val() != '' &&
            validToMonth.find(":selected").index() < validFromMonth.find(":selected").index()) {
          validToMonth.val(validFromMonth.val());
        }
      changeValidToDayOptions();
      }
    }

    function changeValidToDayOptions() {
      validToDayOptions.attr('disabled', false);
      if (validToYear.val() == validFromYear.val() && validFromYear.val() != '' &&
          validToMonth.val() == validFromMonth.val() && validFromMonth.val() != '') {
        validToDayOptions.slice(1, validFromDay.find(":selected").index()).attr('disabled', true);
        if (validToDay.val() != '' && validFromDay.val() != '' &&
            validToDay.find(":selected").index() < validFromDay.find(":selected").index()) {
          validToDay.val(validFromDay.val());
        }
      }
    }
  }

    $('.open-user-account-csv-user-accounts-import').on('click', function (e) {
        $("#user-account-csv-user-accounts-import").modal("show");
    });

    $('#close-import-form').on('click', function (e) {
        $("#user-account-csv-user-accounts-import").modal("hide");
        $("#csv-import-form")[0].reset();
    });
});
